import { render, staticRenderFns } from "./MyVTh.vue?vue&type=template&id=15af81f1&scoped=true&"
import script from "./MyVTh.vue?vue&type=script&lang=js&"
export * from "./MyVTh.vue?vue&type=script&lang=js&"
import style0 from "./MyVTh.vue?vue&type=style&index=0&id=15af81f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af81f1",
  null
  
)

export default component.exports